import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';

/**
 * Shown when a route guard (RoleProtected) blocks access to a page,
 * or when a user follows a deep link to a page their role doesn't cover.
 *
 * Intentionally simple: no fetches, no role checks of its own — it just
 * tells the user what happened and gives them a way back.
 */
const AccessDenied = () => {
    return (
        <div className="page-content">
            <Container fluid>
                <Row className="justify-content-center">
                    <Col xxl={6} lg={8}>
                        <Card className="mt-4">
                            <CardBody className="p-5 text-center">
                                <div className="mb-4 text-warning" style={{ fontSize: 64, lineHeight: 1 }}>
                                    <i className="ri-shield-cross-line"></i>
                                </div>
                                <h3 className="mb-3">Access Denied</h3>
                                <p className="text-muted mb-4">
                                    You don't have permission to view this page. If you believe this
                                    is a mistake, please contact your IT administrator.
                                </p>
                                <div className="d-flex justify-content-center gap-2">
                                    <Button color="primary" tag={Link} to="/dashboard">
                                        <i className="ri-home-2-line align-bottom me-1"></i> Back to Dashboard
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AccessDenied;
